import { useEffect as t } from "react";
const s = (e, n) => {
  t(() => {
    if (!n) return;
    const o = (r) => {
      r.key === "Escape" && (r.stopPropagation(), e());
    };
    return window.addEventListener("keydown", o), () => {
      window.removeEventListener("keydown", o);
    };
  }, [n, e]);
};
export {
  s as useEscapeKey
};
